import client from './client';

const setHeader = () => {
  client.interceptors.request.use(function (config) {
    const token = localStorage.getItem('efub-token');
    config.headers['Authorization'] = `Bearer ${token}`;
    return config;
  });
};

export const loginAdmin = async (password) => {
  try {
    const res = await client.post('api/login', { password: password });
    if (res.status === 200) {
      localStorage.setItem('efub-token', res.data);
      window.location.reload();
      setHeader();
    }
  } catch (e) {
    if (String(e).includes('Error')) return false;
  }
};

export const getApplicationDetail = async (userId) => {
  setHeader();
  try {
    const res = await client.get(`api/admin/application/${userId}`);
    if (res.status === 200) {
      console.log(res.data);
      return res.data;
    }
  } catch (e) {
    console.log(e);
  }
};

export const getApplicationList = async (stage, position) => {
  setHeader();
  try {
    const res = await client.get(`api/admin/list/${stage}/${position}`);
    if (res.status === 200) {
      return res.data;
    }
  } catch (e) {
    console.log(e);
  }
};

export const firstPass = async (userId, status) => {
  setHeader();
  try {
    const res = await client.patch(
      `api/admin/application/${userId}/first?status=${status}`,
    );
    return res;
  } catch (e) {
    console.log(e);
  }
};

export const finalPass = async (userId, status) => {
  setHeader();
  try {
    const res = await client.patch(
      `api/admin/application/${userId}/final?status=${status}`,
    );
    return res;
  } catch (e) {
    console.log(e);
  }
};
